// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xe1xoV1S{display:flex;justify-content:center}.xe1xoV1S img{box-shadow:0 1px 3px color-mix(in srgb, var(--theme-text-emphasis) 10%, transparent);border-radius:var(--radius-small);display:block;max-width:180px;height:auto}`, "",{"version":3,"sources":["webpack://./src/page-components/shared/login/login-code-form.module.scss"],"names":[],"mappings":"AAAA,UACE,YAAA,CACA,sBAAA,CAEA,cACE,oFAAA,CACA,iCAAA,CACA,aAAA,CACA,eAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qr": `xe1xoV1S`
};
export default ___CSS_LOADER_EXPORT___;
